import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './HomePage.css'

function titlee() {
  return document.getElementById('titlee');
}

let title = titlee();

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      line1: 'Hi,',
      line2: "I'm Shanmugavel,",
      line3: 'Web Developer & PLC Programmer.',
      textAnimationLine1: [],
      textAnimationLine2: [],
      textAnimationLine3: [],
      chatbot: false
    }
    // this.timerStart()
  }
  async componentDidMount() {
    title.innerHTML = 'Shan'
    let tempArr1 = []
    let tempArr2 = []
    let tempArr3 = []
    if (this.state.textAnimationLine1.length || this.state.textAnimationLine2.length || this.state.textAnimationLine3.length !== 40) {
      for (let i = 0; i < 40; i++) {
        tempArr1[i] = { letterAni: 0 }
        tempArr2[i] = { letterAni: 0 }
        tempArr3[i] = { letterAni: 0 }
      }
    }
    this.setState({
      chatbot: true,
      textAnimationLine1: tempArr1,
      textAnimationLine2: tempArr2,
      textAnimationLine3: tempArr3,
    })
    var countDownAni = 0;
    setInterval(() => {
      if ((countDownAni) < 40) {
        let arr1 = this.state.textAnimationLine1;
        let arr2 = this.state.textAnimationLine2;
        let arr3 = this.state.textAnimationLine3;
        if (countDownAni === 0) {
          arr1[countDownAni] = { letterAni: 1 }
          arr2[countDownAni] = { letterAni: 1 }
          arr3[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
            textAnimationLine2: arr2,
            textAnimationLine3: arr3
          })
        } else {
          arr1[countDownAni - 1] = { letterAni: 2 }
          arr1[countDownAni] = { letterAni: 1 }
          arr2[countDownAni - 1] = { letterAni: 2 }
          arr2[countDownAni] = { letterAni: 1 }
          arr3[countDownAni - 1] = { letterAni: 2 }
          arr3[countDownAni] = { letterAni: 1 }
          countDownAni++;
          this.setState({
            textAnimationLine1: arr1,
            textAnimationLine2: arr2,
            textAnimationLine3: arr3
          })
        }
      }
    }, 100);
  }

  render() {
    return (<>
      <div className='HomePageDiv'>
        <div className='FirstDiv'>
          <div>
            {this.state.line1.split('').map((ite, index) => {
              return (<>{ite === ' ' && ite !== 'S' ? <span className='AniLetterSpace'>{ite}</span> : ite === 'S' ? <span className='AniLetterS'></span> : <span onMouseEnter={() => {
                let ani = this.state.textAnimationLine1
                ani[index] = { letterAni: 1 }
                this.setState({
                  textAnimationLine1: ani
                })
              }} onMouseLeave={() => {
                setTimeout(() => {
                  let ani = this.state.textAnimationLine1
                  ani[index] = { letterAni: 2 }
                  this.setState({
                    textAnimationLine1: ani
                  })
                }, 500)
              }} className={this.state.textAnimationLine1[index]?.letterAni === 0 || undefined || null ? 'AniLtr' : this.state.textAnimationLine1[index]?.letterAni === 1 ? 'AniLetterMouse AniLetter' : 'AniLetter'}>{ite}</span>}
              </>)
            })}
          </div>
          <div>
            {this.state.line2.split('').map((ite, index) => {
              return (<>{ite === ' ' && ite !== 'S' ? <span className='AniLetterSpace'>{ite}</span> : ite === 'S' ? <span className='AniLetterS'>{ite}</span> : <span onMouseEnter={() => {
                let ani = this.state.textAnimationLine2
                ani[index] = { letterAni: 1 }
                this.setState({
                  textAnimationLine2: ani
                })
              }} onMouseLeave={() => {
                setTimeout(() => {
                  let ani = this.state.textAnimationLine2
                  ani[index] = { letterAni: 2 }
                  this.setState({
                    textAnimationLine2: ani
                  })
                }, 500)
              }} className={this.state.textAnimationLine2[index]?.letterAni === 0 || undefined || null ? 'AniLtr' : this.state.textAnimationLine2[index]?.letterAni === 1 ? 'AniLetterMouse AniLetter' : 'AniLetter'}>{ite}</span>}
              </>)
            })}
          </div>
          <div>
            {this.state.line3.split('').map((ite, index) => {
              return (<>{ite === ' ' && ite !== 'S' ? <span className='AniLetterSpace'>{ite}</span> : ite === 'S' ? <span className='AniLetterS'></span> : <span onMouseEnter={() => {
                let ani = this.state.textAnimationLine3
                ani[index] = { letterAni: 1 }
                this.setState({
                  textAnimationLine3: ani
                })
              }} onMouseLeave={() => {
                setTimeout(() => {
                  let ani = this.state.textAnimationLine3
                  ani[index] = { letterAni: 2 }
                  this.setState({
                    textAnimationLine3: ani
                  })
                }, 500)
              }} className={this.state.textAnimationLine3[index]?.letterAni === 0 || undefined || null ? 'AniLtr' : this.state.textAnimationLine3[index]?.letterAni === 1 ? 'AniLetterMouse AniLetter' : 'AniLetter'}>{ite}</span>}
              </>)
            })}
          </div>
          <div className='detailDescription'>
            Full Stack Web Developer (Front End and Back End) & PLC Programmer
          </div>
          <div onClick={() => {
            let HomePage = {
              SelectedPage: 4
            }
            this.props.SelectedPage('SelectedPage', HomePage)
            this.props.history.push('/Contact')
          }} className='contactDiv'>
            Talk With Me
          </div>
        </div>
        <div className='HomePageChatBot' onClick={() => {
          this.setState({
            chatbot: !this.state.chatbot
          })
        }}>
          <i className={`far fa-comments circleRad ${this.state.chatbot ? 'circleRadClk' : 'circleRadUnClk'}`}></i>
          <div className={this.state.chatbot ? 'HomePageChatBoxMsg' : 'HomePageCHatBotDspl'}>
            <span className='chtboxfstline'>Hi I'm Shanmugavel full Stack Web Developer / Freelancer.</span><br />
            <span className='chtboxscndline'>Feel Free to reach out on mail for any queries.</span>
          </div>
        </div>
      </div>
    </>);
  }
}

const mapStateToProps = () => ({

})

const mapDispatchToProps = (dispatch) => ({
  SelectedPage: (type, payload) => dispatch({
    type: type,
    payload: payload
  })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomePage));